import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { TroubleReport } from 'src/models/troubleReport';

import { BaseAPIService } from './base-api.service';

@Injectable({ providedIn: 'root' })
export abstract class TroubleReportBaseService extends BaseAPIService {
	public abstract getTroubleReports(resultUid: string): Observable<Array<TroubleReport>>;
}
